import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { SortService } from '../../../services/sort-service';

@Component({
  selector: 'app-chips-selector',
  templateUrl: './chips-selector.component.html',
  styleUrls: ['./chips-selector.component.scss']
})
export class ChipsSelectorComponent implements OnInit, AfterViewInit {

  constructor(private sortService: SortService) { }
  /* Componente utilizado para todos los casos en los que se requiera un selector multiple con chips (Ej: filtros )

   * Comportamiento: al seleccionar una opción, esta desaparece del listado y aparece en un listado de chips debajo del selector.
   * Si se quita una opcion del listado de chips, esta vuelve al selector.
   * Si se elige la opción "Todos", el listado se reinicia, los chips se limpian y se devuelve un evento indicando esto ultimo.
   *
   * Las opciones se cargan con un array de objetos:
    * [{
    *   ID: ID del Item a mostrar, éste es el valor que se va a devolver
    *   ItemLabel: Label del Item a mostrar, el nombre del objeto
    * }]
   * El placeholder se setea con la variable input del mismo nombre.
   * Cuando se hace una seleccion, se devuelve por evento un objeto con la info:
    * {
    *   Type: el tipo de selector (string)
    *   SelectedIds: Array Numerico que contiene todos los Ids Seleccionados.
    * }
   * En caso de no hacer uso del evento y necesitar una variable para obtener los valores, obtenerlos de la variable SelectedIds
   * En caso de requerir multiples instancias (Ej: Tablero) se pueden individualizar con la variable Type.
    * */

  public selectorOptions = [];  // array con la lista Original de Opciones, se usa como backup
  @Input() placeholder = '';
  @Input() Type = 'selector';
  @Input() Disabled = false;
  public selectedIds = [];

  tmpSelection: any = undefined;
  private options = [];         // array con los objetos disponibles
  private selectedOptions = []; // array con los objetos seleccionados
  @Output() selectorChangedEvent = new EventEmitter<{Type: string, SelectedIds: Array<number>}>();
  @Output() initialized = new EventEmitter<{}>();
  @Input() opcionTodos = true;

  ngOnInit() {

  }

  ngAfterViewInit() {
    setTimeout(() => this.initialized.emit({}));
  }

  optionsChange(newOptions, selectedIds: Number[] = null) {

    this.options = newOptions;
    this.selectorOptions = newOptions;

    if (selectedIds !== null && selectedIds.length) {
      // cargamos las opciones seleccionadas y quitamos de las opciones de la lista de opciones las ya seleccionadas
      this.selectedIds = selectedIds;
      this.selectedOptions = this.selectorOptions.filter(x => selectedIds.indexOf(x.ID) > -1);
      this.options = this.options.filter(x => selectedIds.indexOf(x.ID) === -1);
    } else {
      this.selectedIds = [];
      this.selectedOptions = [];
    }

  }

  onSelectedItem(e) {
    // Opción "Todos"
    if (e === null) {
      this.options = this.selectorOptions;
      this.selectedIds = [];
      this.selectedOptions = [];
      this.emitEvent(true);
    } else {
      this.selectedOptions.push(this.options.find(x => x.ID === e));
      this.options = this.options.filter(x => x.ID !== e);
      this.selectedIds.push(e);
      this.emitEvent();
    }
    this.tmpSelection = null;
  }

  onRemoveItem(item) {
    this.selectedOptions = this.selectedOptions.filter(x => x.ID !== item.ID);
    this.options.push(item);
    this.selectedIds = this.selectedIds.filter(x => x !== item.ID);
    this.emitEvent();
    this.sortOptions();
    this.tmpSelection = undefined;
  }

  emitEvent(todos = false) {
    if (todos) {
      this.selectorChangedEvent.emit({Type: this.Type, SelectedIds: []});
    } else {
      this.selectorChangedEvent.emit({Type: this.Type, SelectedIds: this.selectedIds});
    }
  }

  // cuando removemos un filtro, este se reinserta en la lista, pero esta queda desordenada, en caso de que dicha
  // lista corresponda a alguno de los siguientes tipos, realizar un sort
  sortOptions() {
    switch (this.Type) {
      case 'producto':
        this.options = this.sortService.chipsSelectProdSort(this.options);
        break;
      case 'zona':
        this.options = this.sortService.chipsSelectIDSort(this.options);
        break;
      case 'cosecha':
        this.options = this.sortService.chipsSelectCosechaSort(this.options);
        break;
      case 'entrega':
        this.options = this.sortService.chipsSelectEntregaSort(this.options);
        break;
      case 'comPrioridad':
      case 'comTipo':
        this.options = this.sortService.chipsSelectIDSort(this.options);
        break;
    }
  }

  unselectAllOptions() {
    this.selectedIds = [];
    this.selectedOptions = [];
    this.options = this.selectorOptions;
    this.tmpSelection = undefined;
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/chips-selector/chips-selector.component.ts